var _path, _path2, _path3, _path4, _path5, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenhouseEffect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.818 27.076s.6 36.402-.613 36.418c-10.58.145-62.707-3.892-62.72-4.653-.048-3.15-1.158-32.034-.644-32.168 15.012-3.91 47.15-3.736 63.977.403",
    fill: "#61b2e4",
    fillOpacity: 0.199
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.32 51.707s6.612.13 11.108-2.467c4.496-2.596 6.2-2.71 6.2-2.71l-.172 11.04-20.87-1.158z",
    fill: "#b1cc33",
    stroke: "#000",
    strokeWidth: 1.512
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.456 57.57s.163 10.71-1.05 10.726c-10.58.145-62.757.486-62.769-.274-.048-3.151-.672-10.72-.159-10.855 15.012-3.91 47.15-3.736 63.978.404",
    fill: "#61b2e4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 57.57c14.189-4.461 46.799-4.318 64.356 0",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.512,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.208 41.56l12.214-21.493s1.94-.577 4.398 1.071c2.738 1.355 5.359 1.375 5.359 1.375L38.402 51.237l-9.654-17.522-7.251 17.302-7.863-19.157-2.522 5.951 2.224-9.668 8.042 17.499 7.132-19.127z",
    fill: "#fcea2b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.111,
    cy: 10.57,
    r: 8.638,
    fill: "#fcea2b",
    fillRule: "evenodd"
  })));
}

export default SvgGreenhouseEffect;